import { useRestaurantName } from 'reservations/account/providers/ConfigProvider';
import { BaseDrawer } from 'reservations/base/components/BaseDrawer';
import { useIsBillSplit } from 'reservations/booking/providers/BookingProvider';
import { useUnenrollChecklessMutation } from 'reservations/checklessPayments/queries/useUnenrollChecklessMutation';

export const RemoveCardModalV2 = () => {
  const restaurantName = useRestaurantName();
  const unenrollMutation = useUnenrollChecklessMutation();
  const isBillSplit = useIsBillSplit();

  return (
    <BaseDrawer
      header="Remove your card"
      primaryButton={{
        label: 'REMOVE CARD',
        variant: 'error',
        onClick: () => unenrollMutation.mutate()
      }}
      secondaryButton={{}}
      requireAuth
      subheader={`Removing your card will remove it from all upcoming reservations at ${restaurantName}. You'll need to pay directly with your server using a traditional payment method for future visits.${isBillSplit ? '\n\nThis action will also cancel your ability to split the bill with members of your party.' : ''}`}
    />
  );
};
